import firebase from 'firebase';

export const firebaseApp = firebase.initializeApp({
  apiKey: __ENV__.FB_APIKEY,
  authDomain: __ENV__.FB_AUTHDOMAIN,
  databaseURL: __ENV__.FB_DATABASEURL,
  storageBucket: __ENV__.FB_STORAGEBUCKET
});
export const firebaseAuth = firebaseApp.auth();
export const firebaseDb = firebaseApp.database();
export const firebaseRefs = {
  root: firebaseDb.ref(),
  users: firebaseDb.ref('users'),
  beeper: {
    events: firebaseDb.ref('beeper/events'),
    people: firebaseDb.ref('beeper/people')
  }
};
export function onAuthStateChanged(callback) {
  firebaseAuth.onAuthStateChanged(user => {
    try {
      if (user) {
        const userUidRef = firebaseRefs.users.child(user.uid);
        const newUser = {};
        // get any extra options saved for that uid
        userUidRef.once('value', snap => {
          if (snap.val()) {
            // if the uid was found, (re)save some user details to users database
            userUidRef.update({
              email: user.email,
              displayName: user.displayName,
            });
            // add extra info to the user object
            newUser.authenticated = true;
            newUser.groups = snap.val().groups;
          }
          newUser.uid = user.uid;
          newUser.photoURL = user.photoURL;
          newUser.displayName = user.displayName;
          newUser.email = user.email;

          callback(newUser);
        });
      } else {
        callback(user);
      }
    } catch(e) {
      console.error(e);
      throw(e);
    }
  }, e => {
    console.error(e.message, e);
  });
}


// WEBPACK FOOTER //
// ./src/store/FirebaseStore.js